import { form } from '../formState'

import { useTexts } from '../../hooks/useTexts'
import { usePhoneValidation } from '../hooks/useFormValidation'
import { useUpdatePhoneRelatedFields } from '../hooks/useUpdatePhoneRelatedFields'

export function CompanyPhone() {
  const texts = useTexts()
  const validatePhone = usePhoneValidation()

  useUpdatePhoneRelatedFields()

  form.useAddFieldValidation<'companyPhone'>('companyPhone', async (field, _formApi) => {
    const companyPhoneValidation = await validatePhone(texts, field.value)
    return companyPhoneValidation.companyPhoneInvalid?.message
  })

  return (
    <>
      <form.TextField
        name="companyPhone"
        testId="companyPhone"
        label={texts.companyPhone}
        validateOn="focus blur"
      />

      <form.Checkbox
        name="showContactPhone"
        testId="showContactPhone"
        label={texts.showContactPhoneonForm}
        validateOn="focus blur"
      />
    </>
  )
}
